"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const v2_1 = require("smartrips-skin/lib/v2");
const getColors = ({ active, disabled, variant, }) => {
    switch (variant) {
        case "blue":
            return `
        ${active &&
                `
          background-color: ${v2_1.theme.colors.blue[500]};
          color: ${v2_1.theme.colors.blue[500]};
          &:hover {
            background-color: ${v2_1.theme.colors.blue[700]};
            color: ${v2_1.theme.colors.blue[700]};
          }
        `}
        ${disabled &&
                `
          background-color: ${!active ? "transparent" : v2_1.theme.colors.blue[300]};
          color: ${!active ? v2_1.theme.colors.blue[500] : v2_1.theme.colors.blue[300]};
          cursor: default;
          &:hover {
          }
        `}
      `;
        case "default":
            return `
        ${active &&
                `
          background-color: ${v2_1.theme.colors.gray[500]};
          color: ${v2_1.theme.colors.gray[500]};
          &:hover {
            background-color: ${v2_1.theme.colors.gray[700]};
            color: ${v2_1.theme.colors.gray[700]};
          }
        `}
        ${disabled &&
                `
          background-color: ${!active ? "transparent" : v2_1.theme.colors.gray[300]};
          color: ${!active ? v2_1.theme.colors.gray[500] : v2_1.theme.colors.gray[300]};
          cursor: default;
          &:hover {
          }
        `}
      `;
        case "green":
            return `
        ${active &&
                `
          background-color: ${v2_1.theme.colors.green[500]};
          color: ${v2_1.theme.colors.green[500]};
          &:hover {
            background-color: ${v2_1.theme.colors.green[700]};
            color: ${v2_1.theme.colors.green[700]};
          }
        `}
        ${disabled &&
                `
          background-color: ${!active ? "transparent" : v2_1.theme.colors.green[300]};
          color: ${!active ? v2_1.theme.colors.green[500] : v2_1.theme.colors.green[300]};
          cursor: default;
          &:hover {
          }
        `}
      `;
        case "pink":
            return `
        ${active &&
                `
          background-color: ${v2_1.theme.colors.pink[500]};
          color: ${v2_1.theme.colors.pink[500]};
          &:hover {
            background-color: ${v2_1.theme.colors.pink[700]};
            color: ${v2_1.theme.colors.pink[700]};
          }
        `}
        ${disabled &&
                `
          background-color: ${!active ? "transparent" : v2_1.theme.colors.pink[300]};
          color: ${!active ? v2_1.theme.colors.pink[500] : v2_1.theme.colors.pink[300]};
          cursor: default;
          &:hover {
          }
        `}
      `;
        default:
            return `
        background-color: ${v2_1.theme.colors.gray[500]};
        color: ${v2_1.theme.colors.gray[500]};
        &:hover {
          background-color: ${v2_1.theme.colors.gray[700]};
          color: ${v2_1.theme.colors.gray[700]};
        }
        &:disabled {
          background-color: ${v2_1.theme.colors.gray[300]};
          color: ${v2_1.theme.colors.gray[300]};
          cursor: default;
          &:hover {
          }
        }
      `;
    }
};
exports.styles = {
    input: styled_1.default.input `
    display: none;
  `,
    switch: {
        indicator: styled_1.default.span `
      align-items: center;
      background-color: ${v2_1.theme.colors.white};
      border-radius: 6px;
      display: flex;
      height: 12px;
      justify-content: center;
      width: 12px;
      transform: ${({ active }) => active ? "translateX(14px)" : "translateX(4px)"};
      transition: all 0.15s ease-in-out;
    `,
        root: styled_1.default.div `
      align-items: center;
      background-color: ${v2_1.theme.colors.gray[100]};
      border-radius: 10px;
      color: ${v2_1.theme.colors.gray[100]};
      cursor: pointer;
      display: flex;
      height: 20px;
      transition: all 0.15s ease-in-out;
      width: 30px;
      ${({ active, disabled, variant }) => getColors({ active, disabled, variant })}
    `,
    },
};
